import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { extendTheme, ChakraProvider, useColorModeValue, Container, Stack, StackDivider, Box, FormControl, Flex, Button, FormLabel, Heading, Text } from '@chakra-ui/react';
import Select from 'react-select';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { useLookupStore } from '../../context/useStore';
import Helmet from 'react-helmet';
import { pubsToApiUrl } from '../../shared/components/functions';

export default function FairsEntry() {
  const { pubcodes } = useLookupStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [pubs, setPubs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  function handleChange(props) {
    setPubs(props, navigate(`${location.pathname}?${pubsToApiUrl({ ...props })}`, { replace: true }));
  }

  function handleSave() {
    setIsLoading(true);
    navigate(`/fairs/form${location.search}`);
  }

  const eventDescription = pubs.map((pub) => pub.description || pub.label).join(', ');

  const theme = extendTheme({
    components: {
      Modal: {
        baseStyle: (props) => ({
          dialog: {
            maxWidth: ['95%', '95%', '95%'],
            minWidth: '95%',
            bg: '#00ff00',
            color: 'red'
          }
        })
      }
    }
  });

  return (
    <ChakraProvider theme={theme}>
      <Helmet>
        <link
          rel="icon"
          href={window.location.href.includes('perfectmoose') ? 'https://perfectmoose.com/favicon.ico' : 'https://schuilenburg.com/wp-content/uploads/2019/03/cropped-schuilenburg-ico.png'}
        />
        <title>{eventDescription ? `Event contact registration - ${eventDescription}` : 'Event contact registration'}</title>
      </Helmet>
      <Container
        py={{
          base: '4',
          md: '8'
        }}
        color="white"
        bgColor={useColorModeValue('sm', 'sm-dark')}
        minH="100vh"
      >
        <Stack spacing="5" divider={<StackDivider />}>
          <Stack spacing="1">
            <Heading as="h1" size="lg">
              Event contact registration
            </Heading>
            {eventDescription && <Text fontSize="lg">{eventDescription}</Text>}
          </Stack>
          <Stack
            direction={{
              base: 'column',
              lg: 'row'
            }}
            spacing={{
              base: '5',
              lg: '8'
            }}
            justify="space-between"
          >
            <Box bg="bg-surface" boxShadow={useColorModeValue('sm', 'sm-dark')} borderRadius="lg" flex="1">
              <Stack
                spacing="5"
                px={{
                  base: '4',
                  md: '6'
                }}
                py={{
                  base: '5',
                  md: '6'
                }}
              >
                <FormControl id="pubcodes">
                  <FormLabel>Select Pubcodes for this event</FormLabel>
                  <div style={{ color: 'black' }}>
                    <Select
                      isMulti
                      name="pubcodes"
                      options={pubcodes.map((pub) => {
                        return {
                          value: pub.counter,
                          description: pub.omschrijving,
                          label: `${pub.kode} (${pub.omschrijving})`
                        };
                      })}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={pubs}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </FormControl>
              </Stack>
              <Flex
                direction="row-reverse"
                py="4"
                px={{
                  base: '4',
                  md: '6'
                }}
              >
                <Button
                  onClick={() => handleSave()}
                  disabled={pubs.length === 0}
                  type="submit"
                  isLoading={isLoading}
                  rightIcon={<FiArrowRight />}
                  h="12"
                  px="7"
                  borderRadius="full"
                  color="white"
                  bg="gray.900"
                  fontWeight="700"
                  letterSpacing="0"
                  boxShadow="0 14px 30px rgba(15, 23, 42, 0.24)"
                  transition="all 160ms ease"
                  _hover={{
                    bg: 'gray.800',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 18px 36px rgba(15, 23, 42, 0.3)'
                  }}
                  _active={{
                    bg: 'gray.950',
                    transform: 'translateY(0)',
                    boxShadow: '0 10px 22px rgba(15, 23, 42, 0.24)'
                  }}
                  _disabled={{
                    bg: 'gray.400',
                    color: 'white',
                    boxShadow: 'none',
                    cursor: 'not-allowed',
                    transform: 'none'
                  }}
                >
                  Go to Form
                </Button>
              </Flex>
            </Box>
          </Stack>
          <Flex
            direction="row-reverse"
            py="4"
            px={{
              base: '4',
              md: '6'
            }}
          >
            <Button
              onClick={() => (window.location = '/')}
              type="submit"
              isLoading={isLoading}
              leftIcon={<FiArrowLeft />}
              variant="outline"
              borderRadius="full"
              color="white"
              borderColor="whiteAlpha.500"
              _hover={{ bg: 'whiteAlpha.200', borderColor: 'whiteAlpha.800' }}
              _active={{ bg: 'whiteAlpha.300' }}
            >
              Back to the admin
            </Button>
          </Flex>
        </Stack>
      </Container>
    </ChakraProvider>
  );
}
